module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/logo_mattrz_cx_full_w-c525dbc05707f5fdce3da3eee536f320.svg";